<template>
  <div class="column full-height">
    <header
      class="row items-center justify-between q-px-2x-md full-width no-wrap"
      :style="{ height: '76px' }"
    >
      <span
        class="text-lg text-neutral text-weight-medium"
        :style="{ maxWidth: '75%' }"
      >
        Bank History Logs
      </span>

      <PBtn color="primary" flat round @click="onClose">
        <CloseIcon class="icon" />
      </PBtn>
    </header>

    <q-separator color="neutral-40" />
    <div class="q-px-2x-md q-py-xl col overflow-auto">
      <div v-if="!timelines?.length">No activity yet!</div>
      <div v-for="(timeline, index) in timelines" :key="index" class="q-mb-lg">
        <div class="flex items-start no-wrap">
          <q-avatar
            color="info-20"
            font-size="15px"
            size="25px"
            text-color="info-70"
          >
            <span class="text-uppercase">
              {{ getAvatarInitials(timeline?.actor?.user_name) }}
            </span>
          </q-avatar>
          <div class="row">
            <span class="q-ml-sm text-sm text-neutral-70">{{
              timeline.description
            }}</span>
          </div>
        </div>
        <div
          v-if="timeline?.current_state?.bank_name"
          class="row text-xs text-weight-medium q-ml-2x-lg"
        >
          {{ formatBankDetails(timeline) }}
        </div>
        <div class="flex text-xs text-neutral justify-end">
          {{ formatDate(timeline.event_time, "DD MMM YYYY, h:mm a") }}
        </div>
      </div>
    </div>
  </div>
</template>
<script setup>
import CloseIcon from "assets/icons/close.svg";
import { date } from "quasar";
import { getAvatarInitials } from "src/assets/scripts/utilities/helpers";

const { formatDate } = date;
const { toggleBankTimelinesDrawer } = useBankStore();
const { timelines } = storeToRefs(useBankStore());

const formatBankDetails = (timeline) => {
  const actionData = timeline?.current_state || {};

  return `${actionData.bank_name || ""} | ${actionData.bank_beneficiary_name || ""} | ${actionData.ifsc_code || ""} | ${actionData.account_number || ""}`;
};

const onClose = () => {
  toggleBankTimelinesDrawer({
    open: false,
    level: 0,
  });
};
</script>
